import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import CustomSelect from '@/core/custom-select/custom-select.vue';
import DisabilityBadge from '@/core/disability-badge/disability-badge.vue';
import { ApplicantInfo } from '@/visa-application/services/special-needs/types';
import { Keywords } from '@/visa-application/models/KeywordsCMSModel';
import { DisabilitiesCMSModel } from '@/visa-application/models/SpecialNeedsCMSModel';

@Component({
  components: {
    CustomSelect: CustomSelect,
    DisabilityBadge: DisabilityBadge
  }
})
export default class SpecialNeeds extends Vue {
  @Prop() public subtitle;
  @Prop() public disabilitiesPlaceholder;
  @Prop() public applicantsPlaceholder;
  @Prop() public commentPlaceholder;
  @Prop({ default: () => [] }) disabilities!: DisabilitiesCMSModel[];
  @Prop({ default: () => [] }) applicants!: ApplicantInfo[];

  @Watch('$store.getters.keywords', { immediate: true })
  public onKeywordsChanged(keywords: Keywords): void {
    this.keywords = keywords;
  }

  public keywords: Partial<Keywords> = {};
  public selectedDisabilities = [];
  public selectedApplicants = [];
  public comment = '';

  get specialNeedsPayload() {
    return this.selectedDisabilities.map(disability => ({
      fIds: this.selectedApplicants.map(applicant => applicant.id).join(','),
      ff_flag: disability.value,
      comment: this.comment
    }));
  }
  get disabilitiesOptions() {
    return this.disabilities.map(disability => ({
      value: disability.name,
      title: disability.title,
      icon: disability.icon_link,
      selected: false
    }));
  }
  get applicantsOptions() {
    return this.applicants.map(applicant => ({
      value: `${applicant.pers_surnames}-${applicant.pers_givennames}`.toLowerCase(),
      title: `${applicant.pers_surnames} ${applicant.pers_givennames}`,
      selected: false,
      id: applicant.f_id
    }));
  }
  get disableConfirmButton() {
    return !this.selectedApplicants.length || !this.selectedDisabilities.length;
  }

  public removeDisability(disability: string) {
    this.selectedDisabilities = this.selectedDisabilities.filter(selectedDisability => selectedDisability.title !== disability);
  }
}
